// Crea un nuovo file: operation-status.pipe.ts
import { inject, Pipe, PipeTransform } from '@angular/core';
import { EtiquetteStoreService } from '../services/etiquette-store.service';
import { EtiquetteApiEnum } from 'src/app/config/entity-api.enum';

@Pipe({
  name: 'etiquetteDecoder',
  standalone: true,
  pure:false
})
export class EtiquetteDecoderPipe implements PipeTransform {
  private readonly etiquetteStoreService = inject(EtiquetteStoreService);

  transform(etiquetteId: number | null | undefined, etiquetteApiEnum: EtiquetteApiEnum): string  {
    if (etiquetteId === null || etiquetteId === undefined) return 'default';
    const etiquette = this.etiquetteStoreService.findReactive(etiquetteApiEnum, etiquetteId)();
    return etiquette?.shortDescription ?? ''+etiquetteId;
  }
}